const keywordApplicabilities = [
  { value: 0x1, description: "Application Questions" },
  { value: 0x2, description: "Measurable Outcomes" },
  { value: 0x4, description: "Budget" },
  { value: 0x8, description: "Letters of Support" },
  { value: 0x10, description: "Grant Details" }
];

export { keywordApplicabilities };
